import { ComponentType } from '@angular/cdk/portal';
import { DataScope, TaskScope } from './global-enum';
import { CategoryPreview } from './category.model';
import { Observable } from 'rxjs';
import { CircleCheck, Info, TriangleAlert } from 'lucide-angular';
import { LucideIconData } from 'node_modules/lucide-angular/icons/types';
import { DialogContent, DialogButtonConfig } from 'src/components/dialog/dialog.component';
import { TableTag } from './document.model';
import { DefaultAssignee } from './user.model';
import { components } from 'be-types';

export type EventTaskSpawnRequest = components['schemas']['EventTaskSpawnRequest'];
export type TaskboardTaskResource = components['schemas']['OpenTasksResource'];

export interface ApiRequestParams {
  scope?: TaskScope;
  dataScope?: DataScope;
  taskType?: number;
  locationID?: number;
  nativeTasks?: number;
  deployed?: number;
  dueStartDate?: string;
  dueEndDate?: string;
  scoredTask?: string;
  completedEndDate?: string;
  completedStartDate?: string;
  categoryID?: number;
  locations?: number[];
  userActive?: string;
}

export interface DashboardGraphs {
  locationID?: number;
  categoryID?: number;
  completionStatus?: string;
}

export interface DialogParams<T, P> {
  getItems?: (req: ApiRequestParams) => Observable<CategoryPreview[]>;

  filterType?: string;
  content?: DialogContent[];
  buttons?: DialogButtonConfig[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  actions?: any;
  cancelLabel?: string | boolean;
  closeDialog?: boolean;
  component?: ComponentType<T>;
  disableClose?: boolean;

  maxHeight?: string;
  messages?: string[];
  minHeight?: string;
  okLabel?: string | boolean;
  payload: P;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  secondary?: any;
  title?: string;
  width?: string;
  height?: string;
  checkBox?: string;
  radioOptions?: string[];
  setDefaultRadioOption?: boolean;
  textInput?: boolean;
  textInputPlaceholder?: string;
  onXClick?: () => void;
  hasBackdrop?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onConfirm?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCancel?: any;
  customStyleClass?: string;
}

export interface TaskboardInfo {
  openTasks: TaskboardTaskResource[];
  closedTasks: TaskboardTaskResource[];
}

export interface EventTask {
  locationID: number;
  summary?: string;
  dueAt?: string;
  userIDs?: number[];
  id?: number;
  profileID?: number;
  TaskOrTaskSet?: string;
  name?: string;
  profileDescription?: string;
  topicTitle?: string;
  allowDeployment: AllowDeployment;
  tags?: TableTag[];
  defaultAssignee?: DefaultAssignee[];
}

export interface AllowDeployment {
  message: string;
  status: boolean;
}

export const StatusIcons: Map<string, LucideIconData> = new Map([
  ['success', CircleCheck],
  ['warning', TriangleAlert],
  ['danger', TriangleAlert],
  ['info', Info],
]);
